import React from 'react'
import { validateMin } from '../../../utils/validateMin';
import { useTheme } from '../../../components/hooks/useTheme';
import { Divider } from '@mui/material';

type TaxChangeProps = {
    locationFeeAmount: number;
    taxAmount: number;
    governmentTaxAmount: number;
    setLocationFeeAmount: (value: number) => void;
    setTaxAmount: (value: number) => void;
    setGovernmentTaxAmount: (value: number) => void;
}

const TaxChange = ({
    locationFeeAmount,
    taxAmount,
    governmentTaxAmount,
    setLocationFeeAmount,
    setTaxAmount,
    setGovernmentTaxAmount
}: TaxChangeProps) => {
    const { themeStyles } = useTheme();

    return (
        <div className="mt-[1.5rem]">
            <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Taxes
            </span>

            <Divider className={`w-full ${themeStyles.divider.bg}`} />

            <div className="grid grid-cols-3 gap-x-6 gap-y-2 mt-[1rem]">
                <div>
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Location Tax %</label>
                    <input
                        type="number"
                        className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                        value={locationFeeAmount}
                        onChange={(e) => {
                            setLocationFeeAmount(validateMin(e.target.value, 0));
                        }}
                    />
                </div>

                <div>
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Sales Tax %</label>
                    <input
                        type="number"
                        className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                        value={taxAmount}
                        onChange={(e) => {
                            setTaxAmount(validateMin(e.target.value, 0));
                        }}
                    />
                </div>

                <div>
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Government Tax %</label>
                    <input
                        type="number"
                        className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                        value={governmentTaxAmount}
                        onChange={(e) => {
                            setGovernmentTaxAmount(validateMin(e.target.value, 0));
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default TaxChange
